module.exports = __webpack_public_path__ + "img/headphone_icon.632985ec.png";